// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg
      width={64}
      height={64}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <style>
        {
          ".WebDesignerIcon__fill--illustration-gray-700{fill:#3f555a;fill:var(--illustration-gray-700, #3F555A)}.WebDesignerIcon__fill--illustration-gray-50{fill:#eef2f3;fill:var(--illustration-gray-50, #EEF2F3)}"
        }
      </style>
      <g
        id="WebDesignerIcon__IconIndustry/Webdesigner-752"
        strokeWidth={1}
        fillRule="evenodd"
        fill="none"
        stroke="none"
      >
        <g
          id="WebDesignerIcon__Kreis/blau/1"
          transform="matrix(1 0 0 -1 0 64)"
          className="WebDesignerIcon__fill--illustration-gray-50"
        >
          <path
            d="M26.228.651c5.684 1.83 11.622 1.83 17.814 0 6.193-1.83 11.734.34 16.624 6.511 2.779 7.09 3.263 13.03 1.454 17.823-1.81 4.793-1.81 10.231 0 16.315 3.259 9.009 2.281 14.487-2.934 16.435-7.822 2.922-23.085-4.55-32.958 2.922C16.356 68.13-7.8 65.111 2.508 30.333 9.382 7.148 17.289-2.746 26.229.651Z"
            id="WebDesignerIcon__Path-6"
          />
        </g>
        <g
          id="WebDesignerIcon__streamline-icon-design-tool-layout@34x34"
          transform="translate(15 15)"
          fillRule="nonzero"
          className="WebDesignerIcon__fill--illustration-gray-700"
        >
          <path
            d="M34 2.805A2.808 2.808 0 0 0 31.195 0H2.805A2.808 2.808 0 0 0 0 2.805v28.39A2.808 2.808 0 0 0 2.805 34h28.39A2.808 2.808 0 0 0 34 31.195V2.805Zm-2.833 27.653a.708.708 0 0 1-.709.709l-26.916.028a.708.708 0 0 1-.709-.708L2.805 3.542c0-.392.317-.709.708-.709l26.945-.028c.392 0 .709.317.709.708v26.945Z"
            id="WebDesignerIcon__Shape"
          />
          <path d="M6.375 23.375h15.583c.783 0 1.417-.634 1.417-1.417V6.375c0-.782-.634-1.417-1.417-1.417H6.375c-.782 0-1.417.635-1.417 1.417v15.583c0 .783.635 1.417 1.417 1.417Zm1.18-4.736L9.8 14.272a1.061 1.061 0 0 1 1.65-.31l1.726 1.53a.357.357 0 0 0 .547-.097l2.458-4.565a1.063 1.063 0 0 1 1.948.18l2.479 7.792a1.063 1.063 0 0 1-1.013 1.386H8.5a1.063 1.063 0 0 1-.945-1.549Z" />
          <path id="WebDesignerIcon__Path" d="M18.417 25.5h4.25v3.542h-4.25z" />
          <path d="M24.792 25.5h4.25v3.542h-4.25zM6.02 28.333h6.376a1.062 1.062 0 1 0 0-2.125H6.02a1.063 1.063 0 0 0 0 2.125ZM26.563 7.083h1.416a1.063 1.063 0 0 0 0-2.125h-1.416a1.063 1.063 0 0 0 0 2.125ZM26.563 12.042h1.416a1.063 1.063 0 0 0 0-2.125h-1.416a1.063 1.063 0 0 0 0 2.125ZM26.563 17h1.416a1.063 1.063 0 0 0 0-2.125h-1.416a1.063 1.063 0 0 0 0 2.125Z" />
        </g>
      </g>
    </svg>
  );
};

const WebDesignerIcon = Icon;
export default WebDesignerIcon;
